require([
  "angular",
  "angular-route",
  "angular-resource",
  "angular-file-upload",
  "bootbox/bootbox",
  "bootstrap-datepicker",
  "bootstrap-toggle/js/bootstrap-toggle",
  "bootstrap",
  "angular-ui-bootstrap/ui-bootstrap-tpls",
  "jquery.scrollto",
  "./app/app",
  "./app/app.routes"
], (
  angular,
  ngRoute,
  ngResource,
  ngFileUpload,
  bootbox,
  bootstrapDatepicker,
  bootstrapToggle,
  bootstrap,
  ui_bootstrap_tpls,
  jQueryScrollTo,
  app,
  appRoutes
) => {
  let $http = angular.injector(["ng"]).get("$http");
  let parsed = {};

  let saved = window.localStorage.getItem("portal_auth");
  if (saved)
    try {
      parsed = JSON.parse(saved);
    } catch (e) {
      parsed = {};
    }

  if (parsed.token) {
    $http({
      method: "POST",
      url: "/api/account/permissions",
      headers: { token: parsed.token }
    })
      .then(res => {
        angular.module("auth").value("session", res.data);
      })
      .catch(() => {
        angular.module("auth").value("session", {});
        window.localStorage.removeItem("portal_auth");
      })
      .finally(() => {
        angular.bootstrap($("html"), ["app"]);
      });
  } else {
    angular.module("auth").value("session", {});
    window.localStorage.removeItem("portal_auth");
    angular.bootstrap($("html"), ["app"]);
  }
});
